import { ReactElement } from "react";
import { FormattedText } from "../FormattedText/FormattedText";
import { localize } from "client_legacy/ndaw/culture";
import { Typography } from "../Typography/Typography";
import { formatList } from "client/Misc/cultureSpecificUtils";

export type SearchKind = "filter" | "search";

export type SearchPlaceholderProps = {
	kind: SearchKind;
	properties: readonly string[];
};

export const SearchPlaceholder = (props: SearchPlaceholderProps): ReactElement => {
	const {
		kind,
		properties
	} = props;

	return (
		<FormattedText
			text={localize(kindToLocalizationKeyMap[kind])}
			thingsToReplace={[
				{
					what: "{{Properties}}",
					filler: (
						<Typography weight="bold" isItalic>
							{formatList(properties)}
						</Typography>
					)
				}
			]}
		/>
	);
};
SearchPlaceholder.displayName = "SearchPlaceholder";

const kindToLocalizationKeyMap: Record<SearchKind, LocalizationKey> = {
	filter: "_FilterByProperties",
	search: "_SearchForProperties"
};
